import { COAST_RINGS, mapPoint } from "./geo";

// 4 sabuk geologi [tAtas, tBawah, warna] — dari bibir rumput (0) ke dasar (1).
const STRATA = [
  [0.00, 0.18, "#6E4730"], // topsoil
  [0.18, 0.50, "#B07D56"], // sub-soil / pasir
  [0.50, 0.80, "#8C583A"], // tanah liat (terracotta)
  [0.80, 1.00, "#4A3B32"], // bedrock
];
function drawCliff(ctx, v, depth) {
  const faces = [];
  for (const ring of COAST_RINGS) {
    const P = ring.map(p => mapPoint(v, p[0], p[1], 0));
    let area2 = 0;
    for (let i = 0; i < P.length; i++) {
      const a = P[i], b = P[(i + 1) % P.length];
      area2 += a[0] * b[1] - b[0] * a[1];
    }
    const sign = area2 > 0 ? 1 : -1;
    const E = P.map((a, i) => {
      const b = P[(i + 1) % P.length];
      const dx = b[0] - a[0], dy = b[1] - a[1];
      return { a, b, dx, dy, len: Math.hypot(dx, dy) };
    });
    const n = E.length;
    for (let i = 0; i < n; i++) {
      const { a, b, dx, dy, len } = E[i];
      if (len < 0.05) continue;
      const ny = (-sign * dx) / len; // komponen-y normal keluar (layar)
      if (ny <= 0) continue; // sisi membelakangi penonton → tertutup rumput
      // Normal HALUS untuk pencahayaan: rata-rata arah 7 tepi tetangga (bobot panjang),
      // agar tepi pantai yang bergerigi mikro tidak berkedip terang-gelap.
      let sx = 0, sy = 0;
      for (let j = -3; j <= 3; j++) { const g = E[(i + j + n) % n]; sx += g.dx; sy += g.dy; }
      const nx = (sign * sy) / (Math.hypot(sx, sy) || 1);
      const ex = (dx / len) * 0.5, ey = (dy / len) * 0.5; // perpanjang 0.5px: tutup celah anti-alias
      faces.push({ ax: a[0] - ex, ay: a[1] - ey, bx: b[0] + ex, by: b[1] + ey, nx, my: (a[1] + b[1]) / 2 });
    }
  }
  faces.sort((p, q) => p.my - q.my); // painter's: belakang → depan
  for (const f of faces) {
    for (const [t0, t1, col] of STRATA) {
      const y0 = depth * t0, y1 = depth * t1 + 0.7; // +0.7px: sabuk saling menindih, tanpa garis celah
      ctx.beginPath();
      ctx.moveTo(f.ax, f.ay + y0); ctx.lineTo(f.bx, f.by + y0);
      ctx.lineTo(f.bx, f.by + y1); ctx.lineTo(f.ax, f.ay + y1);
      ctx.closePath();
      ctx.fillStyle = col;
      ctx.fill();
    }
    // Pencahayaan per sisi: menghadap kanan lebih terang, menghadap kiri lebih gelap.
    ctx.beginPath();
    ctx.moveTo(f.ax, f.ay); ctx.lineTo(f.bx, f.by);
    ctx.lineTo(f.bx, f.by + depth); ctx.lineTo(f.ax, f.ay + depth);
    ctx.closePath();
    ctx.fillStyle = f.nx < 0
      ? `rgba(0,0,0,${(0.22 * -f.nx).toFixed(3)})`
      : `rgba(255,255,255,${(0.10 * f.nx).toFixed(3)})`;
    ctx.fill();
  }
}
// Cache tebing di kanvas offscreen: hanya digambar ulang saat ukuran/kamera berubah.
// Gerak "bob" cukup menggeser hasil cache secara vertikal.
const CLIFF_CACHE = { key: "", cv: null };

// Gambar tebing dari cache; cache dibuat ulang hanya saat ukuran/kamera berubah.
export function drawCliffCached(ctx, v, W, H, dpr, depth, bob) {
  const ck = `${W}|${H}|${dpr}|${v.s.toFixed(4)}|${v.ox.toFixed(2)}|${v.oy.toFixed(2)}`;
  if (CLIFF_CACHE.key !== ck) {
    if (!CLIFF_CACHE.cv) CLIFF_CACHE.cv = document.createElement("canvas");
    const cv = CLIFF_CACHE.cv;
    cv.width = Math.round(W * dpr);
    cv.height = Math.round(H * dpr);
    const c2 = cv.getContext("2d");
    c2.setTransform(dpr, 0, 0, dpr, 0, 0);
    drawCliff(c2, v, depth);
    CLIFF_CACHE.key = ck;
  }
  ctx.drawImage(CLIFF_CACHE.cv, 0, bob, W, H);
}
